import type { Session, GameType } from './types'

/** Read ?token=xxx from URL query string */
export const getTokenFromUrl = (): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}

/** Decode JWT payload (no signature verification — server handles that via Socket.io middleware) */
export const decodeSession = (token: string): Session | null => {
  try {
    const b64 = token.split('.')[1]
    const json = atob(b64.replace(/-/g, '+').replace(/_/g, '/'))
    const payload = JSON.parse(json)
    return {
      player_id:    payload.sub,
      display_name: payload.display_name,
      game_type:    payload.game_type as GameType,
      operator_id:  payload.operator_id,
      currency:     payload.currency ?? 'coins',
      exp:          payload.exp,
    }
  } catch {
    return null
  }
}

export const isTokenExpired = (session: Session) =>
  Date.now() / 1000 > session.exp

/** Notify parent window of events (operator can listen via postMessage) */
export const postToParent = (type: string, data: object) => {
  try {
    window.parent.postMessage({ type, data, source: 'gameprovider' }, '*')
  } catch {}
}

export const GAME_LABELS: Record<string, string> = {
  teen_patti_2card: 'Teen Patti 2-Card',
  teen_patti_3card: 'Teen Patti 3-Card',
  andar_bahar:      'Andar Bahar',
  dragon_tiger:     'Dragon Tiger',
}
